"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricsEntityCount = void 0;
var MetricsEntityCount = /** @class */ (function (_super) {
    __extends(MetricsEntityCount, _super);
    function MetricsEntityCount() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "MetricsEntityCount";
        _this.intents = function () {
            _this.push(function (_) { return "intents"; });
        };
        _this.prompts = function () {
            _this.push(function (_) { return "prompts"; });
        };
        _this.statements = function () {
            _this.push(function (_) { return "statements"; });
        };
        _this.fulfilments = function () {
            _this.push(function (_) { return "fulfilments"; });
        };
        _this.behaviours = function () {
            _this.push(function (_) { return "behaviours"; });
        };
        _this.codes = function () {
            _this.push(function (_) { return "codes"; });
        };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return MetricsEntityCount;
}(Array));
exports.MetricsEntityCount = MetricsEntityCount;
//# sourceMappingURL=MetricsEntityCount.js.map